import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/podcasts/ivds-in-clinical-trials")({
  head: () => buildRouteHead("/es/podcasts/ivds-in-clinical-trials", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/podcasts/ivd-en-ensayos-clinicos-guia-de-supervivencia-para-el-promotor", replace: true });
  },
});
